import {
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { Tenant } from "@models";
import { Divider, Drawer, Image, Rate, Space } from "antd";
import { TenantAvatar } from "./TenantAvatar";
import "./ResumeDrawer.css";

interface ResumeDrawerProps {
  open: boolean;
  onClose: () => void;
  tenant: Tenant;
}

export const ResumeDrawer: React.FC<ResumeDrawerProps> = ({
  open,
  onClose,
  tenant,
}) => {
  const location = [tenant.address, tenant.townName].filter(Boolean).join(", ");
  const hasContact = tenant.phone || tenant.mobile || tenant.email;
  const hasSocial = tenant.instagram || tenant.facebook;

  return (
    <Drawer
      closable
      title={null}
      placement="right"
      open={open}
      onClose={onClose}
      width={640}
      styles={{
        body: { padding: 0 },
        header: { border: "none", padding: "12px 16px 0" },
      }}
    >
      <div className="resume-drawer__header">
        <div className="resume-drawer__hero">
          <TenantAvatar logo={tenant.logo} name={tenant.name} size={80} />
          <div className="resume-drawer__title-group">
            <div className="resume-drawer__name">{tenant.name}</div>
            {location && (
              <div className="resume-drawer__location">
                <EnvironmentOutlined /> {location}
              </div>
            )}
            {tenant.rateCount > 0 && (
              <div className="resume-drawer__rating">
                <Rate disabled allowHalf value={tenant.rate} style={{ fontSize: 13 }} />
                <span className="resume-drawer__rate-count">
                  {tenant.rate.toFixed(1)} ({tenant.rateCount})
                </span>
              </div>
            )}
          </div>
        </div>

        {(hasContact || hasSocial) && (
          <div className="resume-drawer__info-bar">
            <Space size={16} wrap>
              {tenant.phone && (
                <a href={`tel:${tenant.phone}`} className="resume-drawer__contact-link">
                  <PhoneOutlined /> {tenant.phone}
                </a>
              )}
              {tenant.mobile && (
                <a href={`tel:${tenant.mobile}`} className="resume-drawer__contact-link">
                  <PhoneOutlined /> {tenant.mobile}
                </a>
              )}
              {tenant.email && (
                <a href={`mailto:${tenant.email}`} className="resume-drawer__contact-link">
                  <MailOutlined /> {tenant.email}
                </a>
              )}
              {tenant.instagram && (
                <a href={tenant.instagram} target="_blank" rel="noopener noreferrer" className="resume-drawer__contact-link">
                  <InstagramOutlined /> Instagram
                </a>
              )}
              {tenant.facebook && (
                <a href={tenant.facebook} target="_blank" rel="noopener noreferrer" className="resume-drawer__contact-link">
                  <FacebookOutlined /> Facebook
                </a>
              )}
            </Space>
          </div>
        )}
      </div>

      <Divider style={{ margin: 0 }} />

      <div className="resume-drawer__body">
        <Image
          src={tenant.descriptionImage}
          alt={`${tenant.name} resume`}
          style={{ width: "100%", borderRadius: 8 }}
        />
      </div>
    </Drawer>
  );
};
